// extracted by mini-css-extract-plugin
export default {"header":"Header_header__P6TYQ","header__inner":"Header_header__inner__X+zXI","nav":"Header_nav__FovKz"};